import PhoneIcon from '@portalterreno/react-ui-icons/PhoneIcon';
import { PropsWithChildren } from 'react';

import StyledLink, { StyledLinkProps } from './StyledLink';

export type PhoneChipProps = PropsWithChildren<
  Omit<StyledLinkProps, 'href' | 'children'>
>;

const PhoneChip: React.FC<PhoneChipProps> = ({ children, ...rest }) => {
  return (
    <StyledLink
      {...rest}
      href={`tel:${children}`}
    >
      <PhoneIcon />
      {children}
    </StyledLink>
  );
};

export default PhoneChip;
